import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import moment from 'moment';

import { HistoryRecord } from '../schemas';

@Pipe({
  name: 'lcmRelativeTime',
})
export class RelativeTimePipe implements PipeTransform {
  transform(value: string | moment.Moment): unknown {
    return moment(value).fromNow();
  }
}

@Component({
  selector: 'lcm-activity-record',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RelativeTimePipe, MatIconModule],
  template: `
    <mat-icon>{{ icon() }}</mat-icon>
    <span>{{ record().Data.author }} {{ action() }}</span>
    @let text = details();
    @if (text) {
      <pre><code class="mat-bg-secondary mat-text-on-secondary mat-font-body-sm">{{ text }}</code></pre>
    }
    <span class="mat-text-on-surface-variant"> {{ record().Time | lcmRelativeTime }}</span>
  `,
  styles: [
    `
      :host {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 0.5rem;
        > mat-icon {
          grid-row: 1/4;
        }
      }
    `,
    `
      pre {
        margin: 0;
      }
    `,
    `
      code {
        padding: 0.25rem;
        font-size: 0.75rem;
        display: block;
        white-space: break-spaces;
        word-break: break-word;
      }
    `,
  ],
})
export class ActivityRecord {
  record = input.required<HistoryRecord>();

  icon = computed(() => {
    switch (this.record().Data.type) {
      case 'create':
        return 'add';
      case 'update':
      case 'change':
        return 'change_circle';
      default:
        return 'info';
    }
  });

  action = computed(() => {
    switch (this.record().Data.type) {
      case 'create':
        return 'cerated this record';
      case 'update':
        return 'updated';
      case 'change':
        return 'changed';
    }
  });

  details = computed(() => {
    const record = this.record();
    let text = '';
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    let diff: Record<string, [any, any]> | null | undefined;
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    let info: Record<string, any> | null | undefined;

    switch (record.Data.type) {
      case 'update':
        diff = record.Data.diff;
        for (const key in diff) {
          let [a, b] = diff[key];

          if (key.toLowerCase().includes('date')) {
            a = moment(a).format('DD/MM/YYYY');
            b = moment(b).format('DD/MM/YYYY');
          }
          text += `${key}(${a || '{empty}'} -> ${b || '{empty}'}), `;
        }
        text = text.slice(0, -2);
        break;
      case 'change':
        info = record.Data.change;
        for (const key in info) {
          if (key === 'Id') continue;
          text += `${key}(${info[key]}), `;
        }
        text = text.slice(0, -2) || record.Data.action;
        break;
    }
    return text
      .replace(/\),/g, '),\n')
      .replace(/\(\[{/g, '([\n\t{')
      .replace(/\},\{/g, '},\n\t{')
      .replace(/\}\]/g, '}\n]');
  });
}
